<template>
  <div>
    <!-- <AppointmentCard />
    <Toggle />
    <Datepicker />
    <Modal v-if="openModal" title="My Modal">
      Modal content
      <template #footer>
        <Button label="Save"/>
      </template>
    </Modal>
    <Button label="Open Modal" @click="() => openModal = !openModal"/>
      <Accordion /> -->
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import Accordion from "@/stories/Accordion/Accordion.vue";
import AppointmentCard from "@/stories/AppointmentCard/AppointmentCard.vue";
import Button from "@/stories/Buttons/Button.vue";
import Datepicker from "@/stories/Datepicker/Datepicker.vue";
import Modal from "@/stories/Modal/Modal.vue";
import Toggle from "@/stories/Toggle/Toggle.vue";

const openModal = ref(false);
</script>

<style scoped></style>
